import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  title: 'Kit Anti-Visto',
  desc: 'Recuperá el control del chat con respuestas listas para no congelarte cuando te clavan el visto o te contestan seco. Nunca más te quedés en blanco.',
  price: 'AR$ 14.990'
}, {
  n: '02',
  title: 'Aperturas que no dan Cringe',
  desc: 'Empezá conversaciones con naturalidad y gancho, sin sonar básico ni igual a todos. Las aperturas exactas para cada tipo de perfil y contexto.',
  price: 'AR$ 9.990'
}, {
  n: '03',
  title: 'Checklist del Chat que Genera Interés',
  desc: 'Detectá en minutos si tu conversación avanza o se está enfriando, antes de cometer errores irreversibles. Tu radar de interés en tiempo real.',
  price: 'AR$ 7.990'
}, {
  n: '04',
  title: 'Guía Express para Invitar a Salir',
  desc: 'Sabé cuándo y cómo proponer una salida de forma natural para no quedarte eternamente chateando. El paso a paso para que el "sí" sea obvio.',
  price: 'AR$ 7.990'
}, {
  n: '05',
  title: '7 Errores que te hacen ver Necesitado',
  desc: 'Eliminá los hábitos invisibles que bajan tu valor por chat y apagan el interés sin que te des cuenta. El más descargado de los 5 bonos.',
  price: 'AR$ 5.990'
}];
export function Bonuses() {
  return <section aria-label="Bonos" className="bg-ink-2 border-y border-white/5" data-id="element-14" data-mp="3n4mwj4t1ntjm">
      <div className="mx-auto max-w-5xl px-5 py-20 pt-[0px] pb-[22px]" data-id="element-15" data-mp="2zfkhm4psoest">
        <h2 className="text-center font-display text-2xl font-black text-white sm:text-4xl pt-[28px]" data-id="element-16" data-mp="2zhogu9cr0pmr">
          🎁 5 Bonos GRATIS que potencian todo el sistema
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="38h1rh5clzk92">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-gold/25 bg-ink p-6" data-id="element-18" data-mp="33gw4w3l74nxu" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-19" data-mp="3hh81f1j81w1w">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-bold text-gold" data-id="element-20" data-mp="3ljuo6o11cqs8">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="3qhebedfpodwb" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="2tt82hebrazc8">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="2tqlujdkyehth">{b.price}</span>{' '}
                  <span className="text-azul-soft" data-id="element-24" data-mp="2xua4u40yzrif">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="32r0i6jle4905">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="37lefirjm4q7g">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-azul/40 bg-azul/10 p-6 text-center" data-id="element-27" data-mp="2a2d0exzuo1rc">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="2f1pkxc390wqr">
            Valor total de los bonos:{' '}
            <span className="text-white/50 line-through" data-id="element-29" data-mp="27hnghf55bwze">AR$ 46.950</span>{' '}
            <span className="text-gold text-[15px]" data-id="element-30" data-mp="22lpy73abogjz">HOY GRATIS CON TU PROTOCOLO 3C</span>
          </p>
        </div>
      </div>
    </section>;
}